import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { KeyRound, Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const { adminLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return;
    setLoading(true);
    try {
      await adminLogin(pin.trim());
      toast.success('Signed in!');
      navigate('/admin');
    } catch (err) {
      toast.error(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-black">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-xs">
        <div className="glass-card p-8 text-center">
          <div className="w-12 h-12 rounded-full bg-[#E91E8D]/10 border border-[#E91E8D]/20 flex items-center justify-center mx-auto mb-5">
            <Lock size={20} className="text-[#E91E8D]" />
          </div>
          <h1 className="text-white text-lg font-bold mb-1" data-testid="login-title">Admin Access</h1>
          <p className="text-white/30 text-xs mb-6">Enter your PIN to continue</p>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={10}
              value={pin}
              onChange={e => setPin(e.target.value.replace(/\D/g, ''))}
              placeholder="Enter PIN"
              className="input-med w-full text-center text-lg tracking-[0.3em] !py-3 mb-4"
              autoFocus
              data-testid="login-pin"
            />
            <button
              type="submit"
              disabled={loading || !pin.trim()}
              className="btn-pink w-full justify-center !text-sm"
              data-testid="login-submit"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />}
              {loading ? 'Verifying...' : 'Enter'}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
